<template>
  <div style="overflow: hidden; margin-top: -1.8rem">
    <div>
      <div>
        <router-link class="btn btn-info m-2" :to="`/dashboard/all-agents`">
          BACK TO ALL AGENTS
        </router-link>
        <button
          class="btn btn-info m-2"
          style="padding: 8px 40px"
          :to="`/dashboard/all-agents`"
          @click="refreshPage"
        >
          REFRESH
        </button>
      </div>

      <card class="card">
        <div v-if="currentPage === 0">
          <h4>Account Information</h4>

          <div class="accountType-header">
            <div style="width: 100%; max-width: 350px">
              <label>Account Type</label>
              <select
                class="form-control op-border"
                id="accountype"
                v-model="selectedAccountType"
              >
                <option value="">Select</option>
                <option value="individual-account">Individual Account</option>
                <option value="business-account">Business Account</option>
              </select>
            </div>

            <p
              style="
                display: flex;
                align-items: center;
                gap: 16px;
                width: 100%;
                max-width: 350px;
              "
            >
              Requirements
              <span class="ti-info-alt" ref="requirementTooltip"> </span>
            </p>
          </div>

          <div v-if="selectedAccountType" class="info-div">
            <fg-input
              type="date"
              label="Date of Birth"
              placeholder="Date of Birth"
              style="width: 100%; max-width: 350px"
              required
              v-model="agentDetails.dateOfBirth"
            >
            </fg-input>
            <fg-input
              type="text"
              label="BVN"
              placeholder="BVN"
              style="width: 100%; max-width: 350px"
              v-model="agentDetails.bvn"
              @keydown="filterBVN"
              @input="enforceBVNLength"
              required
            >
            </fg-input>
          </div>

          <button
            class="btn btn-info m-2"
            style="padding: 8px 40px"
            :disabled="!agentDetails.bvn || !agentDetails.dateOfBirth"
            @click="verifyBvn"
          >
            <div v-if="loading">
              <div class="spinner-grow" role="status" v-if="loading"></div>
              Verifying
            </div>
            <div v-else>Continue</div>
          </button>
        </div>

        <div v-if="currentPage === 1">
          <div class="accountType">
            <p>Account Type</p>
            <span>Individual</span>
          </div>
          <h3>Personal Information</h3>
          <div>
            <form @submit.prevent="createAgent">
              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="First Name"
                    placeholder="First Name"
                    v-model="agentDetails.firstName"
                    disabled
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Middle Name"
                    placeholder="Middle Name"
                    v-model="agentDetails.middleName"
                    :disabled="agentDetails.middleName"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Last Name"
                    placeholder="Last Name"
                    v-model="agentDetails.lastName"
                    :disabled="agentDetails.lastName"
                    required
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="number"
                    label="Phone Number"
                    placeholder="Phone Number"
                    v-model="agentDetails.phoneNumber"
                    :maxlength="11"
                    @input="filterPhoneNumber"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Email Address"
                    placeholder="Email"
                    v-model="agentDetails.email"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Gender"
                    placeholder="Gender"
                    v-model="agentDetails.gender"
                    :disabled="agentDetails.gender"
                    required
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Nationality"
                    placeholder="Nationality"
                    v-model="agentDetails.nationality"
                    :disabled="agentDetails.nationality"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="number"
                    label="National Identification Number (NIN)"
                    placeholder="National Identification Number (NIN)"
                    v-model="agentDetails.nin"
                    :disabled="agentDetails.nin"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="State of Origin"
                    placeholder="State of Origin"
                    v-model="agentDetails.stateOfOrigin"
                    :disabled="agentDetails.stateOfOrigin"
                    required
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="LGA of Origin"
                    placeholder="LGA of Origin"
                    v-model="agentDetails.lgaOfOrigin"
                    :disabled="agentDetails.lgaOfOrigin"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Residential Address"
                    placeholder="Residential Address"
                    v-model="agentDetails.address"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Landmark "
                    placeholder="Landmark "
                    v-model="agentDetails.landmark"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <label>Social Media Platform</label>
                  <select
                    class="form-control op-border"
                    id="social-media-platform"
                    v-model="selectedSocialMediaPlatform"
                  >
                    <option value="">Select Media Platform</option>
                    <option value="facebook">Facebook</option>
                    <option value="instagram">Instagram</option>
                    <option value="twitter">Twitter</option>
                    <option value="linkedin">Linkedin</option>
                    <option value="tiktok">Tiktok</option>
                    <option value="snapchat">Snapchat</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Social Media Handle"
                    placeholder="Social Media Handle"
                    v-model="agentDetails.socialMediaHandle"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <label>Merchant </label>
                  <select
                    class="form-control op-border"
                    id="rate-type"
                    v-model="selectedMerchant"
                    required
                  >
                    <option value="">Select Merchant</option>
                    <option
                      v-for="merchant in utils.merchants"
                      :key="merchant.id"
                      :value="merchant._id"
                    >
                      {{ merchant.merchantName }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="password"
                    label="Password"
                    placeholder="Password"
                    v-model="agentDetails.password"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="password"
                    label="Password Confirmation"
                    placeholder="Password Confirmation"
                    v-model="confirmPassword"
                    :class="{
                      'is-invalid':
                        submitted &&
                        (!confirmPassword ||
                          confirmPassword !== agent.password),
                    }"
                    required
                  ></fg-input>
                </div>
              </div>

              <div class="form-btns">
                <button
                  class="btn btn-info m-2"
                  style="padding: 8px 48px"
                  @click="goToPage(0)"
                >
                  Back
                </button>
                <div style="padding: 10px">
                  <button
                    type="submit"
                    style="
                      padding: 8px 48px;
                      display: flex;
                      align-items: center;
                      gap: 8px;
                    "
                    class="btn btn-info m-2"
                  >
                    <div
                      class="spinner-border"
                      role="status"
                      v-if="loading"
                    ></div>
                    Continue
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div v-if="currentPage === 3">
          <div class="accountType">
            <p>Account Type</p>
            <span>Individual</span>
          </div>
          <h3>Personal Information</h3>
          <div>
            <form @submit.prevent="createAgent">
              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="First Name"
                    placeholder="First Name"
                    v-model="agentDetails.firstName"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Middle Name"
                    placeholder="Middle Name"
                    v-model="agentDetails.middleName"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Last Name"
                    placeholder="Last Name"
                    v-model="agentDetails.lastName"
                    required
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Phone Number"
                    placeholder="Phone Number"
                    v-model="agentDetails.phoneNumber"
                    :maxlength="11"
                    @input="filterPhoneNumber"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Email Address"
                    placeholder="Email"
                    v-model="agentDetails.email"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="businessState">Gender</label>
                    <select
                      id="gender"
                      class="form-control"
                      v-model="selectedGender"
                      required
                    >
                      <option value="" disabled>Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Nationality"
                    placeholder="Nationality"
                    v-model="agentDetails.nationality"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="number"
                    label="National Identification Number (NIN)"
                    placeholder="National Identification Number (NIN)"
                    v-model="agentDetails.nin"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="businessState">State of Origin</label>
                    <select
                      id="state"
                      class="form-control"
                      v-model="selectedState"
                      @change="fetchLgas"
                      required
                    >
                      <option value="" disabled>Select State</option>

                      <option
                        v-for="state in utils.allStates"
                        :key="state"
                        :value="state"
                      >
                        {{ state }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="localGovernment">LGA of Origin</label>
                    <select
                      id="localGovernment"
                      class="form-control"
                      v-model="agentDetails.lgaOfOrigin"
                      required
                    >
                      <option value="" disabled>Select Local Government</option>
                      <option
                        v-for="lga in utils.lgas"
                        :key="lga.id"
                        :value="lga.name"
                      >
                        {{ lga.name }}
                      </option>
                    </select>
                    <span v-if="utils.lgaLoading">Fetching LGAs...</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Residential Address"
                    placeholder="Residential Address"
                    v-model="agentDetails.address"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Landmark "
                    placeholder="Landmark "
                    v-model="agentDetails.landmark"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <label>Social Media Platform</label>
                  <select
                    class="form-control op-border"
                    id="social-media-platform"
                    v-model="selectedSocialMediaPlatform"
                  >
                    <option value="">Select Media Platform</option>
                    <option value="facebook">Facebook</option>
                    <option value="instagram">Instagram</option>
                    <option value="twitter">Twitter</option>
                    <option value="linkedin">Linkedin</option>
                    <option value="tiktok">Tiktok</option>
                    <option value="snapchat">Snapchat</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Social Media Handle"
                    placeholder="Social Media Handle"
                    v-model="agentDetails.socialMediaHandle"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <label>Merchant </label>
                  <select
                    class="form-control op-border"
                    id="rate-type"
                    v-model="selectedMerchant"
                    required
                  >
                    <option value="">Select Merchant</option>
                    <option
                      v-for="merchant in utils.merchants"
                      :key="merchant.id"
                      :value="merchant._id"
                    >
                      {{ merchant.merchantName }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="password"
                    label="Password"
                    placeholder="Password"
                    v-model="agentDetails.password"
                    required
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="password"
                    label="Password Confirmation"
                    placeholder="Password Confirmation"
                    v-model="confirmPassword"
                    :class="{
                      'is-invalid':
                        submitted &&
                        (!confirmPassword ||
                          confirmPassword !== agentDetails.password),
                    }"
                    required
                  ></fg-input>
                </div>
              </div>

              <div class="form-btns">
                <button
                  class="btn btn-info m-2"
                  style="padding: 8px 48px"
                  @click="goToPage(0)"
                >
                  Back
                </button>
                <div style="padding: 10px">
                  <button
                    type="submit"
                    style="padding: 8px 48px"
                    class="btn btn-info m-2"
                  >
                    <div
                      v-if="loading"
                      style="display: flex; align-items: center; gap: 8px"
                    >
                      <div
                        class="spinner-grow text-primary"
                        role="status"
                      ></div>
                      Creating
                    </div>

                    <div v-else>Continue</div>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div v-if="currentPage === 2">
          <div class="upload-kyc-section">
            <h4>UPLOAD KYC DOCUMENTS</h4>
            <form @submit.prevent="addKycDocs">
              <div class="row">
                <!-- <div class="col-md-4">
                  <fg-input
                    type="number"
                    label="Tax Identification Number (TIN)"
                    placeholder="Tax Identification Number (TIN)"
                    v-model="agentDetails.tin"
                    required
                  ></fg-input>
                </div> -->

                <div class="col-md-4 p-2">
                  <label for="">NIN Image</label>
                  <input
                    type="file"
                    class="form-control"
                    name="ninImg"
                    accept="image/*,application/pdf"
                    @change="handleNinUpload"
                  />
                </div>

                <div class="col-md-4 p-2">
                  <label for="">Proof of Address</label>
                  <input
                    type="file"
                    class="form-control"
                    name="addressImg"
                    accept="image/*"
                    @change="handleAddressUpload"
                  />
                </div>

                <div class="col-md-4 p-2">
                  <label for="">Image</label>
                  <input
                    type="file"
                    class="form-control"
                    name="idCardImg"
                    accept="image/*"
                    @change="handleSelfieUpload"
                    required
                  />
                </div>
              </div>

              <h3 style="font-size: 24px; font-weight: 700">
                Uploaded Documents
              </h3>

              <div class="row">
                <div class="col-md-4">
                  <label style="color: #000">NIN Image</label><br />
                  <template v-if="agentDetails.ninImg">
                    <div
                      class="thumbnail"
                      @mouseover="showViewLink(agentDetails.ninImg)"
                      @mouseleave="hideViewLink(agentDetails.ninImg)"
                    >
                      <img
                        :src="agentDetails.ninImg"
                        class="img-thumbnail"
                        alt="NIN Image"
                      />
                      <div
                        v-if="isViewLinkVisible(agentDetails.ninImg)"
                        class="view-link"
                      >
                        <a
                          @click="expandImage(agentDetails.ninImg)"
                          class="btn btn-info"
                          >View</a
                        >
                      </div>
                      <div
                        v-if="isExpanded(agentDetails.ninImg)"
                        class="expanded-image"
                      >
                        <img
                          :src="agentDetails.ninImg"
                          class="img-thumbnail"
                          alt="NIN Image"
                        />
                        <div class="action-btns">
                          <button
                            class="btn btn-danger btn-sm"
                            @click="closeImage(agentDetails.ninImg)"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div></div>
                  </template>
                </div>

                <div class="col-md-4">
                  <label style="color: #000">Proof of Address</label><br />
                  <template v-if="agentDetails.addressImg">
                    <div
                      class="thumbnail"
                      @mouseover="showViewLink(agentDetails.addressImg)"
                      @mouseleave="hideViewLink(agentDetails.addressImg)"
                    >
                      <img
                        :src="agentDetails.addressImg"
                        class="img-thumbnail"
                        alt="Proof of Address"
                      />
                      <div
                        v-if="isViewLinkVisible(agentDetails.addressImg)"
                        class="view-link"
                      >
                        <a
                          @click="expandImage(agentDetails.addressImg)"
                          class="btn btn-info"
                          >View</a
                        >
                      </div>
                      <div
                        v-if="isExpanded(agentDetails.addressImg)"
                        class="expanded-image"
                      >
                        <img
                          :src="agentDetails.addressImg"
                          class="img-thumbnail"
                          alt="Proof of Address"
                        />
                        <div class="action-btns">
                          <button
                            class="btn btn-danger btn-sm"
                            @click="closeImage(agentDetails.addressImg)"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div></div>
                  </template>
                </div>

                <div class="col-md-4">
                  <label style="color: #000">Image</label><br />
                  <template v-if="agentDetails.liveSelfie">
                    <div
                      class="thumbnail"
                      @mouseover="showViewLink(agentDetails.liveSelfie)"
                      @mouseleave="hideViewLink(agentDetails.liveSelfie)"
                    >
                      <img
                        :src="agentDetails.liveSelfie"
                        class="img-thumbnail"
                        alt="Id Card"
                      />
                      <div
                        v-if="isViewLinkVisible(agentDetails.liveSelfie)"
                        class="view-link"
                      >
                        <a
                          @click="expandImage(agentDetails.liveSelfie)"
                          class="btn btn-info"
                          >View</a
                        >
                      </div>
                      <div
                        v-if="isExpanded(agentDetails.liveSelfie)"
                        class="expanded-image"
                      >
                        <img
                          :src="agentDetails.liveSelfie"
                          class="img-thumbnail"
                          alt="Id Card"
                        />
                        <div class="action-btns">
                          <button
                            class="btn btn-danger btn-sm"
                            @click="closeImage(agentDetails.liveSelfie)"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div></div>
                  </template>
                </div>
              </div>

              <div class="form-btns">
                <div>
                  <button
                    style="padding: 8px 48px"
                    class="btn btn-info m-2"
                    type="submit"
                  >
                    <div
                      v-if="loading"
                      style="display: flex; align-items: center; gap: 8px"
                    >
                      <div class="spinner-border" role="status"></div>
                      Submitting
                    </div>
                    <div v-else>Submit</div>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<style scoped>
.tippy-box[data-theme~="light"] {
  color: #e8e8e8;
  box-shadow: 0 0 20px 4px rgba(154, 161, 177, 0.15),
    0 4px 80px -8px rgba(36, 40, 47, 0.25),
    0 4px 4px -2px rgba(91, 94, 105, 0.15);
  background-color: #1c1c1c;
}
.tippy-box[data-theme~="light"][data-placement^="top"] > .tippy-arrow:before {
  border-top-color: #1c1c1c;
}
.tippy-box[data-theme~="light"][data-placement^="bottom"]
  > .tippy-arrow:before {
  border-bottom-color: #1c1c1c;
}
.tippy-box[data-theme~="light"][data-placement^="left"] > .tippy-arrow:before {
  border-left-color: #1c1c1c;
}
.tippy-box[data-theme~="light"][data-placement^="right"] > .tippy-arrow:before {
  border-right-color: #1c1c1c;
}
.tippy-box[data-theme~="light"] > .tippy-backdrop {
  background-color: #1c1c1c;
}
.tippy-box[data-theme~="light"] > .tippy-svg-arrow {
  fill: #1c1c1c;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import axios from "../store/axios";
import moment from "moment";
import { formatDate } from "../utils/utils";
import tippy from "tippy.js";

export default {
  components: {
    Multiselect,
    tippy,
  },
  data() {
    return {
      agentDetails: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        dateOfBirth: "",
        gender: "",
        phoneNumber: "",
        nationality: "",
        state: "",
        localGovernment: "",
        address: "",
        accountType: "",
        socialMediaPlatform: "",
        socialMediaHandle: "",
        merchantId: "",
        liveSelfie: null,
        addressImg: null,
        ninImg: null,
        password: "",
        bvn: "",
      },
      submitted: false,
      confirmPassword: "",
      loading: false,
      agentId: null,
      loading: false,
      individualTooltip: `<div class="custom-tooltip" style="padding: 10px; border-radius: 8px; background-color: #1c1c1c; color: #fff;">
          <h6>Individual Account - TIER 2 - KYC</h6>

          <p>Personal Information</p>
          <ul>
            <li>Full name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Gender</li>
            <li>Date of birth</li>
            <li>BVN</li>
            <li>NIN</li>
            <li>Nationality</li>
            <li>State of origin</li>
            <li>LGA of origin</li>
            <li>Residential address</li>
            <li>Landmark</li>
            <li>Selfie (Image)</li>
          </ul>

          

          <b>Transfer limit capped at N50,000 per transaction</b> </br>
          <b style="margin-bottom: 20px;">Daily cumulative limit capped at N200,000 per day</b>
            <p></p>
          <p>Individual Account - TIER 3 - KYC</p>

          <ul>
            
<li>National ID Card</li>
<li>Proof of Address (Utility bill - Not older than 6 months)</li>
            
          </ul>

          <b>Transfer limit capped at N500,000 per transaction</b> </br>
          <b>Daily cumulative limit capped at N1,000,000 per day</b>
        </div>`,
      businessTooltip: "Requirements for a Business Account",
      tooltipInstance: null,

      selectedAccountType: "",
      currentPage: 0,
      previousPage: null,
      selectedGender: "",
      selectedState: "",
      selectedLocalGovernment: "",
      selectedMerchant: "",
      selectedSocialMediaPlatform: "",
      viewLinkVisible: {},
      expandedImages: [],
      newlyCreatedAgent: null,
    };
  },
  computed: {
    ...mapState(["auth", "utils"]),
    accountTypeDisplay() {
      return "Individual Account";
    },
  },
  methods: {
    goToPage(page) {
      this.currentPage = page;
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    ...mapActions([
      "getStates",
      "getLgas",
      "getCountries",
      "setLoading",
      "setNotification",
      "getMerchants",
    ]),
    refreshPage() {
      window.location.reload();
    },
    handleSelfieUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.agentDetails.liveSelfie = reader.result;
        };
        reader.readAsDataURL(file);
        this.selectedliveSelfieFile = file;
      }
    },
    handleAddressUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.agentDetails.addressImg = reader.result;
        };
        reader.readAsDataURL(file);
        this.selectedAddressFile = file;
      }
    },
    handleNinUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.agentDetails.ninImg = reader.result;
        };
        reader.readAsDataURL(file);
        this.selectedNinFile = file;
      }
    },
    isViewLinkVisible(imageUrl) {
      return this.viewLinkVisible[imageUrl] || false;
    },
    showViewLink(imageUrl) {
      this.$set(this.viewLinkVisible, imageUrl, true);
    },
    hideViewLink(imageUrl) {
      this.$set(this.viewLinkVisible, imageUrl, false);
    },
    expandImage(imageUrl) {
      if (!this.isExpanded(imageUrl)) {
        this.expandedImages.push(imageUrl);
      }
    },
    closeImage(imageUrl) {
      this.expandedImages = this.expandedImages.filter(
        (imgUrl) => imgUrl !== imageUrl,
      );
    },
    isExpanded(imageUrl) {
      return this.expandedImages.includes(imageUrl);
    },

    handleContinue() {
      this.previousPage = this.currentPage;
      this.currentPage = 2;
    },
    goBack() {
      if (this.previousPage) {
        this.currentPage = this.previousPage;
      } else {
        console.warn("No previous tab to navigate to.");
      }
    },
    validateForm() {
      const isBVNValid =
        this.agentDetails.bvn && /^\d{11}$/.test(this.agentDetails.bvn);

      return isBVNValid && this.agentDetails.password === this.confirmPassword;
    },

    async verifyBvn() {
      if (!/^\d{11}$/.test(this.agentDetails.bvn)) {
        Swal.fire({
          title: "Invalid BVN",
          text: "Please enter a valid BVN. BVN should be 11 digits.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      this.loading = true;

      try {
        let payload = {
          dateOfBirth: formatDate(this.agentDetails.dateOfBirth),
          bvn: this.agentDetails.bvn,
        };
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/validateBvn`,
          payload,
        );

        console.log(response.data);

        if (response.data.status === "success") {
          this.agentDetails = response.data.data;
          this.agentDetails.bvn = payload.bvn;
          this.agentDetails.dateOfBirth = payload.dateOfBirth;
          Swal.fire({
            title: "Validation Successful",
            text: `${response.data.message}`,
            icon: "success",
            confirmButtonText: "OK",
            showCancelButton: false,
          });
          this.loading = false;
          this.goToPage(1);
        } else if (response.data.status === "failed") {
          this.loading = false;
          Swal.fire({
            title: "Validation Failed",
            text: `${response.data.message}`,
            icon: "error",
            confirmButtonText: "OK",
            showCancelButton: false,
          });
          this.goToPage(3);
        }
      } catch (err) {
        this.error = true;
        this.errorMsg = "Unable to get agent details";
        Swal.fire({
          title: "Validation Failed",
          text: `${this.errorMsg}`,
          icon: "error",
          confirmButtonText: "OK",
          showCancelButton: false,
        });
        this.loading = false;
        this.goToPage(3);
      }
    },

    async createAgent() {
      const formData = new FormData();
      formData.append("firstName", this.agentDetails.firstName);
      formData.append("middleName", this.agentDetails.middleName);
      formData.append("lastName", this.agentDetails.lastName);
      formData.append("phoneNumber", this.agentDetails.phoneNumber);
      formData.append("email", this.agentDetails.email);
      formData.append(
        "gender",
        this.agentDetails.gender.toLowerCase() || this.selectedGender,
      );
      formData.append("nationality", this.agentDetails.nationality);
      formData.append("nin", this.agentDetails.nin);
      formData.append(
        "state",
        this.agentDetails.stateOfOrigin || this.selectedState,
      );
      formData.append("bvn", this.agentDetails.bvn || this.bvn);
      formData.append(
        "dateOfBirth",
        this.agentDetails.dateOfBirth || this.dateOfBirth,
      );
      formData.append("address", this.agentDetails.address);
      formData.append("landmark", this.agentDetails.landmark || "");
      formData.append("localGovernment", this.agentDetails.lgaOfOrigin);
      formData.append(
        "socialMediaPlatform",
        this.agentDetails.socialMediaPlatform ||
          this.selectedSocialMediaPlatform ||
          "",
      );
      formData.append(
        "socialMediaHandle",
        this.agentDetails.socialMediaHandle || "",
      );
      formData.append("password", this.agentDetails.password);
      formData.append("tin", this.agentDetails.tin || "");
      formData.append("accountType", this.selectedAccountType);
      formData.append("merchantId", this.selectedMerchant);

      if (!(this.agentDetails.password === this.confirmPassword)) {
        Swal.fire({
          title: "Form Incomplete",
          text: "Please ensure passwords match.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      this.loading = true;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/add-personal-details`,
          formData,
        );

        if (response.data.status === "success") {
          this.agentId = response.data.agent._id;
          // Swal.fire({
          //   title: "Agent Created Successfully",
          //   html: `You have have created an Individual account for <b>${response.data.agent.firstName} ${response.data.agent.lastName}</b> with </br> <b>Wallet ID: ${response.data.agent.walletId}</b> `,
          //   icon: "success",
          //   confirmButtonText: "OK",
          //   showCancelButton: false,
          // });
          this.newlyCreatedAgent = response.data.agent;

          this.currentPage = 2;

          this.loading = false;

          this.goToPage(2);
        } else if (response.data.status === "failed") {
          Swal.fire({
            title: "Agent Failed",
            text: `${response.data.message}`,
            icon: "error",
            confirmButtonText: "OK",
            showCancelButton: false,
          });
          this.loading = false;
        } else {
          this.loading = false;
        }
      } catch (err) {
        this.error = true;

        Swal.fire({
          title: "Personal details addition Failed",
          text: `${err.response.data.message}`,
          icon: "error",
          confirmButtonText: "OK",
          showCancelButton: false,
        });
        this.loading = false;
      }
    },

    async addKycDocs() {
      this.loading = true;
      const formData = new FormData();
      formData.append("agentId", this.agentId);
      formData.append("liveSelfie", this.selectedliveSelfieFile);
      formData.append("addressImg", this.selectedAddressFile);
      formData.append("ninImg", this.selectedNinFile);

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API_URL}/kyc/update-kyc-docs/${this.agentId}`,
          formData,
        );

        if (response.data.status === "success") {
          this.loading = false;
          Swal.fire({
            title: "Agent Created Successfully",
            html: `You have have created an Individual account for <b>${this.newlyCreatedAgent.firstName} ${this.newlyCreatedAgent.lastName}</b> with </br> <b>Wallet ID: ${this.newlyCreatedAgent.walletId}</b> `,
            icon: "success",
            confirmButtonText: "OK",
            showCancelButton: false,
          }).then(() => {
            this.loading = false;
            this.$router.push({ name: "All Agents" });
          });
        } else if (response.data.status === "failed") {
          Swal.fire({
            title: "KYC Documents Addition Failed",
            text: `${response.data.message}`,
            icon: "error",
            confirmButtonText: "OK",
            showCancelButton: false,
          });
        } else {
          this.loading.show = false;
        }
      } catch (err) {
        this.error = true;

        Swal.fire({
          title: "KYC Documents Addition Failed",
          text: `${err.response.data.message}`,
          icon: "error",
          confirmButtonText: "OK",
          showCancelButton: false,
        });
      }
    },

    fetchLgas() {
      this.agentDetails.lgaOfOrigin = "";
      this.getLgas(this.selectedState).then((lgas) => {
        this.lgas = lgas;
      });
    },

    filterPhoneNumber() {
      const value = this.agentDetails.phoneNumber.replace(/\D/g, "");
      this.agentDetails.phoneNumber = value.slice(0, 11);
    },
    enforceBVNLength() {
      this.agentDetails.bvn = this.agentDetails.bvn
        .replace(/\D/g, "")
        .slice(0, 11);
    },
    filterBVN(event) {
      const allowedKeys = [
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "Delete",
        "Tab",
      ];
      const isNumberKey = /^[0-9]$/.test(event.key);

      if (!isNumberKey && !allowedKeys.includes(event.key)) {
        event.preventDefault();
      }
    },
  },
  mounted() {
    this.getMerchants();
    this.getStates().then((states) => {
      this.utils.allStates = states;
    });

    // tippy(this.$refs.requirementTooltip, {
    //   content: this.individualTooltip,
    //   arrow: true,
    //   animation: "fade",
    //   placement: "bottom",
    //   allowHTML: true,
    //   theme: "light",
    // });

    this.tooltipInstance = tippy(this.$refs.requirementTooltip, {
      content: "Please select an account type",
      trigger: "mouseenter focus",
      arrow: true,
      animation: "fade",
      placement: "bottom",
      allowHTML: true,
      theme: "light",
    });
  },

  watch: {
    selectedAccountType(newVal) {
      if (newVal === "individual-account") {
        this.tooltipInstance.setContent(this.individualTooltip);
      } else if (newVal === "business-account") {
        this.tooltipInstance.setContent(this.businessTooltip);
      } else {
        this.tooltipInstance.setContent("Please select an account type");
      }
    },
  },
};
</script>

<style scoped>
.section-button {
  background: none;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  color: #000;
  position: relative;
  text-decoration: none;
}

.section-button::after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: transparent;
  transition: all 0.3s ease;
}

.section-button:hover::after {
  width: 100%;
  background-color: #c35800;
}

.section-button::after {
  width: 100%;
  background-color: #00c307;
}

.is-invalid {
  border-color: #dc3545;
}

.is-invalid + .invalid-feedback {
  display: block;
}

.accountType-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 40px 0;
}

.info-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 90px;
}

.form-btns {
  display: flex;
  align-items: center;
}

.custom-tooltip {
  font-size: 14px;
  border-radius: 8px;
  max-width: 300px;
  line-height: 1.5;
}

.custom-tooltip ul {
  list-style-type: disc;
  text-align: left;
  margin-bottom: 16px;
}

.custom-tooltip ul li {
  margin-bottom: 4px;
}
</style>
